module.exports = __webpack_public_path__ + "img/logo.fb83f167.png";